const cityTypes = ["город", "city", "місто"];

export default (settlementType, settlement) => {
	const type = settlementType || "";
	if (cityTypes.includes(settlementType)) {
		return settlement;
	}
	if (type) {
		return `${type} ${settlement}`.trim();
	}
	return settlement || "";
};
